import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.research');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type LocalText = { ko: string; en: string };
type ResearchCategoryKey = 'papers' | 'patents' | 'projects';

type ResearchCategory = {
    key: ResearchCategoryKey;
    label: LocalText;
    icon: string;
};

type PaperItem = {
    id?: string;
    no: number;
    year: string;
    title: string;
    kind: string;
    venue: string;
    link?: string;
    visible?: boolean;
};

type PatentItem = {
    title: LocalText;
    registrationNumber: string;
    applicationNumber: string;
    filingDate: string;
    registrationDate: string;
    assignee: LocalText;
    inventors: string;
    summary: LocalText;
    tags: string[];
    image: string;
    figureAlt: LocalText;
    kiprisUrl: string;
};

type ProjectItem = {
    id?: string;
    no: number;
    year: string;
    title: string;
    program: string;
    role: LocalText;
    status: LocalText;
    period: string;
    visible?: boolean;
};

type YearGroup<T> = {
    year: string;
    items: T[];
};

@Component({
    selector: 'wiz-page-research',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.research/view.scss */
:host {
  display: block;
}

:host *,
:host *::before,
:host *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}

.section-eyebrow {
  margin: 0 0 14px;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.research-hero {
  position: relative;
  min-height: 380px;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #fff;
  background: #11100f;
}

.research-hero-bg,
.research-hero-grid {
  position: absolute;
  inset: 0;
}

.research-hero-bg {
  background: radial-gradient(circle at 84% 14%, rgba(254, 90, 51, 0.28), transparent 34%), linear-gradient(135deg, #0C0A09 0%, #181413 58%, #251815 100%);
}

.research-hero-grid {
  opacity: 0.4;
  background-image: linear-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.2), #000 34%, #000 78%, rgba(0, 0, 0, 0.18));
  -webkit-mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.2), #000 34%, #000 78%, rgba(0, 0, 0, 0.18));
}

.research-hero-inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 410px;
  align-items: center;
  gap: 56px;
  padding: 64px 0 58px;
}

.research-hero-copy {
  max-width: 720px;
}
.research-hero-copy h1 {
  margin: 0;
  font-size: 44px;
  line-height: 1.16;
  font-weight: 800;
  letter-spacing: 0;
}
.research-hero-copy p {
  margin: 18px 0 0;
  max-width: 660px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  line-height: 1.75;
}

.research-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 700;
}

.research-kicker-mark {
  width: 30px;
  height: 2px;
  border-radius: 1px;
  background: #FE5A33;
}

.research-summary {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(12, 10, 9, 0.58);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  overflow: hidden;
}

.summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.summary-head span {
  color: rgba(255, 255, 255, 0.52);
  font-size: 16px;
  font-weight: 700;
}
.summary-head strong {
  color: #fff;
  font-size: 16px;
  font-weight: 800;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.summary-item {
  min-height: 102px;
  padding: 20px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.summary-item:nth-child(2n) {
  border-right: 0;
}
.summary-item:nth-last-child(-n+2) {
  border-bottom: 0;
}

.summary-value {
  display: block;
  color: #fff;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  word-break: keep-all;
  overflow-wrap: normal;
}

.summary-label {
  display: block;
  margin-top: 9px;
  color: rgba(255, 255, 255, 0.56);
  font-size: 16px;
  line-height: 1.45;
}

.research-overview {
  padding: 72px 0 88px;
  background: #fff;
}

.overview-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 30px;
}
.overview-heading .section-eyebrow {
  margin-bottom: 0;
}
.overview-heading p {
  margin: 0;
  max-width: 820px;
  color: #52525b;
  font-size: 16px;
  line-height: 1.75;
}

.category-tabs {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  margin: 0 -16px 30px;
  background: #fff;
  border-bottom: 1px solid transparent;
  box-shadow: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.category-tabs.stuck {
  border-bottom-color: #f1f1f3;
  box-shadow: 0 10px 22px rgba(24, 24, 27, 0.06);
}

.category-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  color: #52525b;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.category-tab i {
  font-size: 16px;
  flex: 0 0 auto;
  line-height: 1;
}
.category-tab span {
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
  white-space: nowrap;
}
.category-tab:hover, .category-tab.active {
  border-color: rgba(254, 90, 51, 0.42);
  background: #FFF5F2;
  color: #E04420;
}
.category-tab.active {
  box-shadow: 0 8px 18px rgba(254, 90, 51, 0.12);
}

.research-panel {
  min-height: 420px;
}

.panel-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}
.panel-title h3 {
  margin: 0;
  color: #18181b;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0;
}
.panel-title .panel-count {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border: 1px solid #e4e4e7;
  border-radius: 999px;
  background: #fafafa;
  color: #71717a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
}

.year-group + .year-group {
  margin-top: 42px;
}

.year-divider {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 12px;
  margin-bottom: 10px;
}
.year-divider::after {
  content: "";
  grid-column: 2;
  grid-row: 1;
  height: 1px;
  background: #e4e4e7;
}
.year-divider strong {
  grid-column: 1;
  grid-row: 1;
  color: #FE5A33;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
}
.year-divider .year-count {
  grid-column: 3;
  grid-row: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
  color: #a1a1aa;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.paper-row {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr) 86px;
  gap: 18px;
  align-items: center;
  min-height: 86px;
  padding: 18px 0;
  border-bottom: 1px solid #e4e4e7;
  transition: background 0.18s ease;
}
.paper-row:hover {
  background: #fafafa;
}
.paper-row:last-child {
  border-bottom: 0;
}

.paper-index {
  color: #a1a1aa;
  font-size: 16px;
  font-weight: 800;
}

.paper-main {
  min-width: 0;
}
.paper-main h4 {
  margin: 0;
  color: #18181b;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.5;
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: normal;
}

.paper-title-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: inherit;
  text-decoration: none;
}
.paper-title-link i {
  flex: 0 0 auto;
  color: #a1a1aa;
  font-size: 16px;
  transition: color 0.18s ease;
}
.paper-title-link:hover {
  color: #e04420;
}
.paper-title-link:hover i {
  color: #e04420;
}

.paper-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 9px;
}
.paper-meta span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}

.paper-year {
  justify-self: end;
  color: #71717a;
  font-size: 16px;
  font-weight: 800;
}

.project-row {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr) 86px;
  gap: 18px;
  align-items: center;
  min-height: 92px;
  padding: 18px 0;
  border-bottom: 1px solid #e4e4e7;
  transition: background 0.18s ease;
}
.project-row:hover {
  background: #fafafa;
}
.project-row:last-child {
  border-bottom: 0;
}

.project-index {
  color: #a1a1aa;
  font-size: 16px;
  font-weight: 800;
}

.project-main {
  min-width: 0;
}
.project-main h4 {
  margin: 0;
  color: #18181b;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.5;
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: normal;
}

.project-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 9px;
}
.project-meta span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}
.project-meta .project-status {
  background: #FFF5F2;
  color: #E04420;
  font-weight: 800;
}

.project-year {
  justify-self: end;
  color: #71717a;
  font-size: 16px;
  font-weight: 800;
}

.patent-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.patent-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.patent-card:hover {
  transform: translateY(-2px);
  border-color: rgba(254, 90, 51, 0.38);
  box-shadow: 0 16px 34px rgba(24, 24, 27, 0.08);
}

.patent-figure {
  position: relative;
  aspect-ratio: 16/9;
  border-bottom: 1px solid #e4e4e7;
  background: #f8fafc;
}
.patent-figure span {
  position: absolute;
  left: 14px;
  top: 12px;
  z-index: 1;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: rgba(24, 24, 27, 0.82);
  color: #fff;
  font-size: 16px;
  font-weight: 800;
}
.patent-figure img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.patent-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 18px;
  padding: 22px;
}
.patent-body p {
  margin: 0;
  color: #52525b;
  font-size: 16px;
  line-height: 1.7;
}

.patent-head {
  display: grid;
  gap: 10px;
}
.patent-head h4 {
  margin: 0;
  color: #18181b;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.45;
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: normal;
}

.patent-status {
  width: fit-content;
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border-radius: 8px;
  background: #ecfdf5;
  color: #059669;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}

.patent-meta-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}
.patent-meta-grid div {
  min-width: 0;
  padding: 13px 14px;
  border-right: 1px solid #e4e4e7;
  border-bottom: 1px solid #e4e4e7;
}
.patent-meta-grid div:nth-child(2n) {
  border-right: 0;
}
.patent-meta-grid div:nth-last-child(-n+2) {
  border-bottom: 0;
}
.patent-meta-grid span {
  display: block;
  margin-bottom: 6px;
  color: #a1a1aa;
  font-size: 16px;
  font-weight: 800;
}
.patent-meta-grid strong {
  display: block;
  color: #18181b;
  font-size: 16px;
  font-weight: 800;
  word-break: keep-all;
  overflow-wrap: normal;
}

.patent-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.patent-tags span {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 10px;
  border-radius: 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}

.patent-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #e4e4e7;
}
.patent-foot > span {
  min-width: 0;
  color: #71717a;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.55;
}

.patent-link {
  flex: 0 0 auto;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-radius: 8px;
  background: #18181b;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;
}
.patent-link i {
  font-size: 16px;
}
.patent-link:hover {
  background: #E04420;
  color: #fff;
  transform: translateY(-1px);
  text-decoration: none;
}

.project-ready {
  display: grid;
  justify-items: center;
  gap: 10px;
  padding: 54px 20px;
  border-bottom: 1px solid #e4e4e7;
  text-align: center;
}
.project-ready h4 {
  margin: 4px 0 0;
  color: #18181b;
  font-size: 20px;
  font-weight: 800;
}
.project-ready p {
  max-width: 520px;
  margin: 0;
  color: #71717a;
  font-size: 16px;
  line-height: 1.7;
}

.ready-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #FFF5F2;
  color: #E04420;
}
.ready-icon i {
  font-size: 23px;
}

@media (max-width: 1024px) {
  .research-hero-inner {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .research-summary {
    max-width: 520px;
  }
  .patent-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .research-hero {
    min-height: 340px;
  }
  .research-hero-inner {
    padding: 50px 0;
  }
  .research-hero-copy h1 {
    font-size: 34px;
  }
  .research-hero-copy p {
    font-size: 16px;
  }
  .summary-value {
    font-size: 24px;
  }
  .research-overview {
    padding: 56px 0 68px;
  }
  .panel-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }
  .paper-row {
    grid-template-columns: 1fr;
    gap: 8px;
    align-items: start;
    padding: 17px 0;
  }
  .project-row {
    grid-template-columns: 1fr;
    gap: 8px;
    align-items: start;
    padding: 17px 0;
  }
  .paper-year {
    justify-self: start;
  }
  .project-year {
    justify-self: start;
  }
  .patent-body {
    padding: 18px;
  }
  .patent-meta-grid {
    grid-template-columns: 1fr;
  }
  .patent-meta-grid div {
    border-right: 0;
  }
  .patent-meta-grid div:nth-last-child(-n+2) {
    border-bottom: 1px solid #e4e4e7;
  }
  .patent-meta-grid div:last-child {
    border-bottom: 0;
  }
  .patent-foot {
    align-items: flex-start;
    flex-direction: column;
  }
}`],
})
export class PageResearchComponent implements OnInit, OnDestroy {
    public selectedCategory: ResearchCategoryKey = 'papers';
    public isTabsStuck = false;
    public papersLoaded = false;
    public projectsLoaded = false;
    public papersError = false;
    public projectsError = false;
    private scrollContainer: HTMLElement;
    private readonly handleContentScroll = () => this.updateTabsStickiness();

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.loadPapers();
        await this.loadProjects();
        await this.service.render();
        this.bindScrollContainer();
        this.updateTabsStickiness();
    }

    public ngOnDestroy() {
        const container = this.getScrollContainer();
        if (container) container.removeEventListener('scroll', this.handleContentScroll);
    }

    public copy = {
        heroTitle: {
            ko: '연구 성과와 수행 이력',
            en: 'Research Outcomes and Track Record'
        },
        heroDesc: {
            ko: '시즌은 논문, 특허, 연구과제 수행 경험을 제품 개발과 사업화로 연결해 왔습니다.',
            en: 'SEASON connects papers, patents, and funded research experience to product development and commercialization.'
        },
        summaryLabel: {
            ko: '성과 요약',
            en: 'Portfolio Summary'
        },
        overviewDesc: {
            ko: '로드맵 자료 기준 논문 성과와 주요 등록 특허, 정부지원 선정 연구과제를 최신순으로 정리해 제공합니다.',
            en: 'Publications, key registered patents, and selected government-funded R&D programs are organized newest first.'
        },
        papersTitle: {
            ko: '논문 및 학술 발표',
            en: 'Papers and Conference Publications'
        },
        patentsTitle: {
            ko: '주요 등록 특허',
            en: 'Key Registered Patents'
        },
        projectsTitle: {
            ko: '연구과제',
            en: 'R&D Programs'
        },
        projectsReadyTitle: {
            ko: '준비중입니다',
            en: 'Coming soon'
        },
        projectsReadyDesc: {
            ko: '연구과제 이력은 논문과 동일한 연도별 리스트 형식으로 정리해 공개할 예정입니다.',
            en: 'R&D program history will be published in the same year-grouped list format as the publications.'
        },
        kiprisLink: {
            ko: 'KIPRIS에서 보기',
            en: 'View on KIPRIS'
        },
        patentFigureLabel: {
            ko: '특허 도면',
            en: 'Patent Drawing'
        },
        applicationLabel: {
            ko: '출원번호',
            en: 'Application No.'
        },
        registrationLabel: {
            ko: '등록번호',
            en: 'Registration No.'
        },
        filingLabel: {
            ko: '출원일',
            en: 'Filing Date'
        },
        registrationDateLabel: {
            ko: '등록일',
            en: 'Registration Date'
        }
    };

    public stats = [
        { value: '-', label: { ko: '논문/컨퍼런스', en: 'Papers & Conferences' } },
        { value: '2', label: { ko: '주요 등록 특허', en: 'Key Patents' } },
        { value: '-', label: { ko: '정부지원 과제', en: 'Funded R&D Programs' } },
        { value: '-', label: { ko: 'SCI 논문', en: 'SCI Papers' } }
    ];

    public categories: ResearchCategory[] = [
        { key: 'papers', label: { ko: '논문', en: 'Papers' }, icon: 'icon-file-text' },
        { key: 'patents', label: { ko: '특허', en: 'Patents' }, icon: 'icon-badge-check' },
        { key: 'projects', label: { ko: '연구과제', en: 'R&D Programs' }, icon: 'icon-flask-conical' }
    ];

    public papers: PaperItem[] = [];

    public patents: PatentItem[] = [
        {
            title: {
                ko: '문서적합성 기반 맞춤형 질의응답 서비스 제공시스템 및 방법',
                en: 'System and method for providing customized question and answer service based on document relevance'
            },
            registrationNumber: 'KR102813388B1',
            applicationNumber: '1020240104584',
            filingDate: '2024.08.06',
            registrationDate: '2025.05.27',
            assignee: { ko: '주식회사 시즌', en: 'SEASON CO. LTD.' },
            inventors: '채영훈, 이대겸, 조호현',
            summary: {
                ko: '검색 문서의 최신성과 관련성을 평가해 맞춤형 컨텍스트를 생성하고 LLM 응답에 활용하는 문서검색 및 질의응답 기술입니다.',
                en: 'A document search and Q&A technology that scores retrieved documents for recency and relevance, then generates custom context for LLM responses.'
            },
            tags: ['LLM', 'Document Search', 'RAG'],
            image: '/assets/research/patent-document-qa.png',
            figureAlt: {
                ko: '문서 적합성 기반 질의응답 서비스 특허 도면',
                en: 'Patent drawing for document relevance based question answering service'
            },
            kiprisUrl: 'https://www.kipris.or.kr/khome/search/searchResult.do?searchKind=totalSearch&queryText=1020240104584&queryTextTop=1020240104584&expression=1020240104584&searchInTrans=N&searchInComplate=N'
        },
        {
            title: {
                ko: '이미지와 질의문의 복합분석을 이용한 대화형 인공지능 서비스 제공시스템 및 방법',
                en: 'System and method for providing conversational artificial intelligence service using complex analysis of image and query'
            },
            registrationNumber: 'KR102785215B1',
            applicationNumber: '1020240084604',
            filingDate: '2024.06.27',
            registrationDate: '2025.03.21',
            assignee: { ko: '주식회사 시즌', en: 'SEASON CO. LTD.' },
            inventors: '채영훈, 이대겸, 조호현',
            summary: {
                ko: '사용자 질문과 이미지를 함께 분석하고 이미지 관련 참고자료를 검색해 더 정교한 대화형 AI 답변을 생성하는 기술입니다.',
                en: 'A conversational AI technology that analyzes both a user query and an image, retrieves image-related references, and generates more precise answers.'
            },
            tags: ['Multimodal AI', 'Image Analysis', 'Chatbot'],
            image: '/assets/research/patent-image-query.png',
            figureAlt: {
                ko: '이미지와 질의문 복합분석 기반 대화형 인공지능 서비스 특허 도면',
                en: 'Patent drawing for conversational AI service using image and query analysis'
            },
            kiprisUrl: 'https://www.kipris.or.kr/khome/search/searchResult.do?searchKind=totalSearch&queryText=1020240084604&queryTextTop=1020240084604&expression=1020240084604&searchInTrans=N&searchInComplate=N'
        }
    ];

    public projects: ProjectItem[] = [];

    public selectCategory(category: ResearchCategoryKey) {
        if (this.selectedCategory === category) return;

        const shouldResetScroll = this.shouldResetPanelScroll();
        this.selectedCategory = category;
        this.service.render();
        setTimeout(() => {
            if (shouldResetScroll) this.scrollToPanelTop();
            this.updateTabsStickiness();
        }, 0);
    }

    public paperGroups(): YearGroup<PaperItem>[] {
        return this.groupByYear(this.papers);
    }

    private async loadPapers() {
        this.papersError = false;
        this.papers = [];
        try {
            const result = await wiz.call('papers');
            const rows = result?.code === 200 ? result.data?.data : null;
            if (!Array.isArray(rows)) throw new Error('Invalid papers response');
            this.papers = this.normalizePapers(rows);
        } catch {
            this.papersError = true;
        }
        this.papersLoaded = true;
        this.updatePaperStats();
    }

    private async loadProjects() {
        this.projectsError = false;
        this.projects = [];
        try {
            const result = await wiz.call('projects');
            const rows = result?.code === 200 ? result.data?.data : null;
            if (!Array.isArray(rows)) throw new Error('Invalid projects response');
            this.projects = this.normalizeProjects(rows);
        } catch {
            this.projectsError = true;
        }
        this.projectsLoaded = true;
        this.updateProjectStats();
    }

    public projectGroups(): YearGroup<ProjectItem>[] {
        return this.groupByYear(this.projects);
    }

    public categoryLabel(type: ResearchCategoryKey) {
        const category = this.categories.find(item => item.key === type);
        return category ? this.text(category.label) : type;
    }

    public text(value: LocalText) {
        if (!value) return '';
        const lang = this.currentLang;
        return value[lang] || value.en || value.ko || '';
    }

    public get currentLang(): 'ko' | 'en' {
        try {
            return this.service.lang.get() === 'ko' ? 'ko' : 'en';
        } catch {
            return 'en';
        }
    }

    private groupByYear<T extends { year: string }>(items: T[]): YearGroup<T>[] {
        const groups: YearGroup<T>[] = [];
        items.forEach(item => {
            let group = groups.find(entry => entry.year === item.year);
            if (!group) {
                group = { year: item.year, items: [] };
                groups.push(group);
            }
            group.items.push(item);
        });
        return groups;
    }

    private normalizePapers(rows: any[]): PaperItem[] {
        const normalized: PaperItem[] = [];
        rows.forEach((item, index) => {
            if (!item || item.visible === false) return;
            const title = this.cleanText(item.title);
            if (!title) return;
            normalized.push({
                id: this.cleanText(item.id) || `paper-${index + 1}`,
                no: this.toNumber(item.no, normalized.length + 1),
                year: this.cleanText(item.year),
                title,
                kind: this.cleanText(item.kind),
                venue: this.cleanText(item.venue),
                link: this.cleanText(item.link),
                visible: item.visible !== false
            });
        });
        return normalized;
    }

    private normalizeProjects(rows: any[]): ProjectItem[] {
        const normalized: ProjectItem[] = [];
        rows.forEach((item, index) => {
            if (!item || item.visible === false) return;
            const title = this.cleanText(item.title);
            if (!title) return;
            normalized.push({
                id: this.cleanText(item.id) || `project-${index + 1}`,
                no: this.toNumber(item.no, normalized.length + 1),
                year: this.cleanText(item.year),
                title,
                program: this.cleanText(item.program),
                role: this.localText(item.role),
                status: this.localText(item.status),
                period: this.cleanText(item.period),
                visible: item.visible !== false
            });
        });
        return normalized;
    }

    private updatePaperStats() {
        const sciCount = this.papers.filter(item => (item.kind || '').toLowerCase().indexOf('sci') >= 0).length;
        if (this.stats[0]) this.stats[0].value = this.papersError ? '-' : String(this.papers.length);
        if (this.stats[3]) this.stats[3].value = this.papersError ? '-' : String(sciCount);
    }

    private updateProjectStats() {
        if (this.stats[2]) this.stats[2].value = this.projectsError ? '-' : String(this.projects.length);
    }

    private cleanText(value: any) {
        if (value === null || value === undefined) return '';
        return String(value).trim();
    }

    private localText(value: any): LocalText {
        if (value && typeof value === 'object') {
            return {
                ko: this.cleanText(value.ko),
                en: this.cleanText(value.en)
            };
        }
        const text = this.cleanText(value);
        return { ko: text, en: text };
    }

    private toNumber(value: any, fallback: number) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    }

    private bindScrollContainer() {
        const container = this.getScrollContainer();
        if (!container) return;
        container.removeEventListener('scroll', this.handleContentScroll);
        container.addEventListener('scroll', this.handleContentScroll, { passive: true });
    }

    private getScrollContainer(): HTMLElement {
        if (this.scrollContainer && document.body.contains(this.scrollContainer)) return this.scrollContainer;
        this.scrollContainer = document.querySelector('.layout-content') as HTMLElement;
        return this.scrollContainer;
    }

    private updateTabsStickiness() {
        const container = this.getScrollContainer();
        const tabs = document.querySelector('wiz-page-research .category-tabs') as HTMLElement;
        if (!container || !tabs) return;

        const containerTop = container.getBoundingClientRect().top;
        const isStuck = tabs.getBoundingClientRect().top <= containerTop + 1 && container.scrollTop > 0;
        if (this.isTabsStuck === isStuck) return;

        this.isTabsStuck = isStuck;
        this.service.render();
    }

    private shouldResetPanelScroll() {
        if (this.isTabsStuck) return true;

        const container = this.getScrollContainer();
        const panel = document.querySelector('wiz-page-research .research-panel') as HTMLElement;
        const tabs = document.querySelector('wiz-page-research .category-tabs') as HTMLElement;
        if (!container || !panel) return false;

        const tabsHeight = tabs ? tabs.offsetHeight : 0;
        return panel.getBoundingClientRect().top < container.getBoundingClientRect().top + tabsHeight;
    }

    private scrollToPanelTop() {
        const container = this.getScrollContainer();
        const panel = document.querySelector('wiz-page-research .research-panel') as HTMLElement;
        const tabs = document.querySelector('wiz-page-research .category-tabs') as HTMLElement;
        if (!container || !panel) return;

        const containerTop = container.getBoundingClientRect().top;
        const panelTop = panel.getBoundingClientRect().top;
        const tabsHeight = tabs ? tabs.offsetHeight : 0;
        const top = container.scrollTop + panelTop - containerTop - tabsHeight - 18;
        container.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    }
}

export default PageResearchComponent;